package com.eladfinish.bible.contest.screens.mikud.api

import com.eladfinish.bible.contest.network.DefaultApiResult
import com.eladfinish.bible.contest.network.apiTextResultUtf16Bom
import io.ktor.client.HttpClient
import io.ktor.client.request.get

/**
 * Fetches the syllabus ("מיקוד") .txt files from the data repo on GitHub. These mirror the
 * legacy UTF-16LE local assets under `moko-resources/assets/mikudLevels` byte-for-byte, so the
 * same intro/part1/part2 parsing pipeline ([GetMikudLevelInfoUseCase]) applies to either source.
 */
interface SyllabusGithubApi {
    suspend fun getSyllabusFile(relativePath: String): DefaultApiResult<String>
}

class SyllabusGithubApiImpl(
    private val client: HttpClient,
) : SyllabusGithubApi {

    companion object {
        private const val BASE_URL =
            "https://raw.githubusercontent.com/elfifo4/chidon-hatanach-data/main/content/syllabuses"
    }

    override suspend fun getSyllabusFile(relativePath: String): DefaultApiResult<String> =
        apiTextResultUtf16Bom { client.get("$BASE_URL/$relativePath") }
}
